/**
 * Глобальный сигнал «открыть окно входа/регистрации» из любого места
 * приложения (а не только с лендинга). Нужен, например, чтобы гость,
 * у которого закончились кредиты, мог нажать «Создать аккаунт» прямо в
 * приложении — AppLayout рендерит <AuthDialog>, управляемый этим стором.
 */
import { create } from "zustand";

type Mode = "login" | "signup";

interface AuthDialogState {
  open: boolean;
  mode: Mode;
  openDialog: (mode?: Mode) => void;
  setOpen: (v: boolean) => void;
}

export const useAuthDialog = create<AuthDialogState>((set) => ({
  open: false,
  mode: "signup",
  openDialog: (mode = "signup") => set({ open: true, mode }),
  setOpen: (v) => set({ open: v }),
}));
